import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/** Bump this to force the tour to re-show for all users on major releases. */
const TOUR_VERSION = 1

interface TourState {
  active: boolean
  step: number
  completed: boolean
  version: number

  start: () => void
  next: () => void
  back: () => void
  skip: () => void
  complete: () => void
  restart: () => void
}

export const useTourStore = create<TourState>()(
  persist(
    (set) => ({
      active: false,
      step: 0,
      completed: false,
      version: TOUR_VERSION,

      start: () => set({ active: true, step: 0 }),
      next: () => set((s) => ({ step: s.step + 1 })),
      back: () => set((s) => ({ step: Math.max(0, s.step - 1) })),
      skip: () => set({ active: false, completed: true }),
      complete: () => set({ active: false, completed: true }),
      // restart: clears completion so TourLauncher re-appears on /app
      restart: () => set({ active: false, step: 0, completed: false }),
    }),
    {
      name: 'lifeodds.tour',
      onRehydrateStorage: () => (state) => {
        // Re-show tour if the stored version is older than current
        if (state && state.version < TOUR_VERSION) {
          state.completed = false
          state.step = 0
          state.version = TOUR_VERSION
        }
      },
    },
  ),
)
